import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Crop from '@src/components/Crop';
import Node from '@src/components/ProfileNode';
import Subtitle from '@src/components/ProfileSubtitle';
import ProfileComment from '@src/components/ProfileComment';

import useStyles from 'isomorphic-style-loader/useStyles';
import css from '@src/components/PageProfile/style.module.sass';

const VenueProfile = (props) => {
	useStyles(css);
	const {
		TitleRP,
		description,
		HeaderGallery: Header,
		ProfileSubmenu: Menu,
		FitEvents,
		FilesList,
		VenueFeatures: Feature,
		RoomsList,
		SidebarRP,
		ProfileAlbums: Album,
		albumsQtty: counterAlbum,
		albumFuncQtty,
		FeedbacksList: Review,
		ProfileFeedSummary: ReviewRate,
		rateQtty: counterReview,
		allFeedBacksLink: hrefLoadmoreReview,
		GiftLine,
		DiscussSection: Comment,
		discussQtty: counterComment,
		onShowMoreDiscussions: onClickLoadmoreComment,
		PackRP,
		counterPack,
		NoDataState,
		AdminPanel,
		PriceBlock,
		AlbumFunc,
		schema,
	} = props;

	return (
		<div className={css.group}>
			{schema && (
				<script
					type="application/ld+json"
					// eslint-disable-next-line react/no-danger
					dangerouslySetInnerHTML={{
						__html: schema,
					}}
				/>
			)}
			{Header && <Header />}

			<div className={css.wrap}>
				<div className={css.content}>
					{TitleRP && <TitleRP />}

					{Menu && <Menu />}

					<div className={css.separatorCustom} />

					{GiftLine && <GiftLine />}

					{FitEvents && (
						<div className={css.item} id="overview">
							{FitEvents && (
								<>
									<Subtitle
										label={t('Подходит для мероприятий')}
									/>
									<div className={css.event}>
										<FitEvents />
										{description && (
											<Crop
												value={t('Развернуть')}
												maxHeight={120}
											>
												{description}
											</Crop>
										)}
									</div>
								</>
							)}
						</div>
					)}

					{PriceBlock && (
						<div className={css.item}>
							<PriceBlock />
						</div>
					)}

					{FilesList && (
						<div className={css.item}>
							<FilesList />
						</div>
					)}

					{RoomsList && (
						<div className={cn(css.item, css.room)} id="rooms">
							<RoomsList />
						</div>
					)}

					{Feature && (
						<div className={css.item} id="features">
							<Node state="about" label={t('Описание')}>
								<Feature />
							</Node>
						</div>
					)}

					{PackRP && (
						<div className={css.item} id="packs">
							<Node
								state="pack"
								label={t('Пакетные предложения')}
								counter={counterPack}
							>
								<PackRP />
							</Node>
						</div>
					)}

					{AlbumFunc && (
						<>
							<div className={css.item} id="albums">
								<Node
									state="albumsFunc"
									label={t('Альбомы')}
									counter={albumFuncQtty}
								>
									<div>
										<AlbumFunc />
									</div>
								</Node>
							</div>
							<div className={css.separator} />
						</>
					)}

					{Album && (
						<>
							<div className={css.item}>
								<Node
									state="album"
									label={t('Мероприятия у нас')}
									counter={counterAlbum}
								>
									<Album />
								</Node>
							</div>
							<div className={css.separator} />
						</>
					)}

					{Review && (
						<div className={css.item} id="rates">
							<Node
								state="review"
								label={t('Отзывы')}
								counter={counterReview}
								labelLoadmore={t('Смотреть все отзывы')}
								hrefLoadmore={hrefLoadmoreReview}
							>
								<ReviewRate />
								<Review />
							</Node>
						</div>
					)}

					{Comment && (
						<div className={css.item}>
							<Node
								label={t('Обсуждение')}
								counter={counterComment}
							>
								<ProfileComment
									labelLoadmore={t(
										'Показать ещё комментарии',
									)}
									onClickLoadmore={onClickLoadmoreComment}
								>
									<Comment />
								</ProfileComment>
							</Node>
						</div>
					)}

					{NoDataState && <NoDataState />}
				</div>

				{SidebarRP && (
					<div className={css.sidebar}>
						<SidebarRP />
					</div>
				)}
			</div>

			{AdminPanel && <AdminPanel />}
		</div>
	);
};

VenueProfile.propTypes = {
	TitleRP: PropTypes.elementType,
	description: PropTypes.string,
	allFeedBacksLink: PropTypes.string,
	HeaderGallery: PropTypes.elementType,
	ProfileSubmenu: PropTypes.elementType,
	RoomsList: PropTypes.elementType,
	ProfileAlbums: PropTypes.elementType,
	albumsQtty: PropTypes.number,
	FeedbacksList: PropTypes.elementType,
	ProfileFeedSummary: PropTypes.elementType,
	rateQtty: PropTypes.number,
	GiftLine: PropTypes.elementType,
	counterPack: PropTypes.number,
	PackRP: PropTypes.elementType,
	NoDataState: PropTypes.elementType,
	DiscussSection: PropTypes.elementType,
	discussQtty: PropTypes.number,
	onShowMoreDiscussions: PropTypes.func,
	FilesList: PropTypes.elementType,
	FitEvents: PropTypes.elementType,
	VenueFeatures: PropTypes.elementType,
	schema: PropTypes.string,
	AdminPanel: PropTypes.elementType,
	SidebarRP: PropTypes.elementType,
	PriceBlock: PropTypes.elementType,
	AlbumFunc: PropTypes.elementType,
	albumFuncQtty: PropTypes.number,
};

VenueProfile.defaultProps = {
	TitleRP: undefined,
	description: undefined,
	allFeedBacksLink: undefined,
	HeaderGallery: null,
	ProfileSubmenu: null,
	RoomsList: null,
	ProfileAlbums: null,
	albumsQtty: 0,
	albumFuncQtty: 0,
	FeedbacksList: null,
	ProfileFeedSummary: undefined,
	rateQtty: 0,
	GiftLine: null,
	counterPack: undefined,
	PackRP: undefined,
	NoDataState: null,
	DiscussSection: undefined,
	discussQtty: 0,
	onShowMoreDiscussions: undefined,
	FilesList: undefined,
	FitEvents: undefined,
	VenueFeatures: undefined,
	schema: undefined,
	AdminPanel: undefined,
	PriceBlock: undefined,
	SidebarRP: null,
	AlbumFunc: undefined,
};

export default VenueProfile;
